import React from "react";
import { DxToggle, DxButton } from "genesys-react-components";
import { GenesysDevIcons } from "genesys-dev-icons";
import { Org } from "./Org";
import { DivisionFilter } from "./DivisionFilter";
import "../App.css";
import { ObjectFilter } from "./ObjectFilter";

export function LeftPanel({
  darkThemeEnabled,
  setDarkThemeEnabled,
  divisions,
  checkedDivisions,
  setCheckedDivisions,
  setOrg,
  opts,
  setOpts,
  tabName,
  filters,
  setFilters,
  isVisible,
}) {
  const activeDivisionCount = checkedDivisions.length;
  const filterCount = Object.keys(filters).filter(
    (key) => key !== "checkedDivisions" && filters[key]
  ).length;

  const onApplyFilters = () => {
    // You can add any additional logic here if needed
    // setCheckedDivisions(checkedDivisions);
    setFilters({
      ...filters,
      checkedDivisions,
      ...opts,
    });
  };

  return (
    <div className="left-panel">
      <div className="left-panel-section left-panel-header">
        <div className="left-panel-brand">
          <span className="left-panel-eyebrow">Maximus</span>
          <span className="left-panel-app-name">Catalogue Controls</span>
        </div>
        <DxToggle
          className="theme-toggle"
          value={darkThemeEnabled}
          falseIcon={GenesysDevIcons.AppSun}
          trueIcon={GenesysDevIcons.AppMoon}
          onChange={(value) => setDarkThemeEnabled(value === true)}
        />
      </div>

      <div className="left-panel-section org-section">
        <Org setOrg={setOrg} />
      </div>

      {(isVisible.divisions || isVisible.object) && (
        <div className="left-panel-section filter-section">
          {/* <div className="left-panel-section-title">Filters</div> */}
          {isVisible.divisions && (
            <DivisionFilter
              divisions={divisions}
              checkedDivisions={checkedDivisions}
              setCheckedDivisions={setCheckedDivisions}
            />
          )}
          {isVisible.object && (
            <ObjectFilter opts={opts} setOpts={setOpts} tabName={tabName} />
          )}
        </div>
      )}

      {isVisible.applyButton && (
        <div className="left-panel-section apply-filters-section">
          <div className="active-filter-summary">
            <span className="filter-summary-chip">
              {activeDivisionCount} divisions selected
            </span>
            <span className="filter-summary-chip">
              {filterCount} filters applied
            </span>
          </div>
          <DxButton variant="primary" onClick={onApplyFilters}>
            Apply Filters
          </DxButton>
        </div>
      )}
    </div>
  );
}
